export enum AcceptHeader {
  Plain = 'application/expanded+json',
  HATEOAS = 'application/json',
}
